import requests from "./httpService";

const PermitServices = {
  getAllPermit: async () => {
    return requests.get(`/permit/`);
  },

  addPermit: async (body) => {
  
    return requests.post(`/permit/add`,body);
  },
  getPermitById: async (id) => {

    return requests.get(`/permit/${id}`);
  },

  updatePermit: async (id, body) => {
  
    return requests.put(`/permit/update/${id}`,body);
  },

  deletePermit: async (id) => {
    return requests.delete(`/permit/delete/${id}`);
  },
};

export default PermitServices;
